import axios from 'axios';
import { Message } from 'element-ui';

const apiBase = process.env.VUE_APP_API_BASE_URL || '';
const service = axios.create({
  baseURL: apiBase ? apiBase.replace(/\/?$/, '/') : '',
  timeout: 10000
});

service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const skipErrorHandler = error.config && error.config.skipErrorHandler;
    if (!skipErrorHandler && error.message) {
      Message.error(error.message);
    }
    return Promise.reject(error);
  }
);

export default service;
